(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/shared/hooks/use-games-by-tags.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/shared/hooks/use-games-by-tags.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const useGamesByTags = _ref => {
  let game = _ref.game;
  const mounted = React.useRef(true);
  const _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    loading = _useState2[0],
    setLoading = _useState2[1];
  const _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    games = _useState4[0],
    setGames = _useState4[1];
  useEffect(() => {
    mounted.current = true;
    const fetchAllGames = async () => {
      try {
        const tags = game.tags,
          type = game.type;
        const allGames = await svs.eInstant.shared.util.fetchAllGames();
        const filteredGames = allGames.filter(_ref2 => {
          let gameTags = _ref2.tags;
          return gameTags.some(t => tags.includes(t));
        }).filter(_ref3 => {
          let gameType = _ref3.type;
          return gameType !== type;
        }).filter(svs.eInstant.util.validateGameConfig).sort((a, b) => new Date(b.publishedDate) - new Date(a.publishedDate)).sort((a, b) => {
          const aCommonTags = a.tags.filter(t => tags.includes(t)).length;
          const bCommonTags = b.tags.filter(t => tags.includes(t)).length;
          return bCommonTags - aCommonTags;
        }).slice(0, 6);
        mounted.current && setGames(filteredGames);
      } catch (e) {
        svs.eInstant.logger.error('Failed to fetch games', e);
      } finally {
        mounted.current && setLoading(false);
      }
    };
    fetchAllGames();
    return () => {
      mounted.current = false;
    };
  }, [game.url]);
  return {
    games,
    loading
  };
};
setGlobal('svs.eInstant.shared.hooks.useGamesByTags', useGamesByTags);

 })(window);